import React from "react";
import { IconType } from "./type";

const IconMin = ({ width = 17, height = 3, fill = "#424244" }: IconType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.28 0H15.37C15.6591 0 15.9363 0.114839 16.1407 0.319254C16.3452 0.523668 16.46 0.800914 16.46 1.09C16.4613 1.23398 16.4341 1.3768 16.3799 1.5102C16.3257 1.6436 16.2457 1.76494 16.1443 1.86722C16.043 1.9695 15.9223 2.05068 15.7894 2.10608C15.6565 2.16148 15.514 2.19001 15.37 2.19H1.09C0.946014 2.19001 0.803453 2.16148 0.670552 2.10608C0.537652 2.05068 0.417044 1.9695 0.315697 1.86722C0.214349 1.76494 0.134269 1.6436 0.0800835 1.5102C0.0258976 1.3768 -0.00132087 1.23398 9.99316e-08 1.09V1.09C9.99316e-08 0.800914 0.114839 0.523668 0.319254 0.319254C0.523668 0.114839 0.800914 0 1.09 0L9.28 0Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconMin;
